'use strict';

var d3 = require('d3');
var ChartDemandTransparency = function ChartDemandTransparency(AbstractChart, chartGroups, chartSimpleBars, chartSimpleBarsOverlays, chartXAxisCircles, chartXAxis, chartYAxis, chartBrush, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var simpleBars = chartSimpleBars('m1');
    var simpleBarsOverlays = chartSimpleBarsOverlays('m1');
    var xAxisCircles = chartXAxisCircles('seasonOverride', 'fillOverride', 'opacity');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var brush = chartBrush();
    brush.on('brushchange', function (range) {
      dispatch.rangechange(range);
      this.brushChangeAction(range, groups);
    }.bind(this));
    this.render = function (data, range) {
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([yAxisLeft, groups, simpleBars, simpleBarsOverlays, xAxis, xAxisCircles], this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.withMetric = function (metric) {
      yAxisLeft.label(metric);
      return this;
    };
    this.setSelection = function (selectionSize) {
      brush.setSelection([0, selectionSize], true);
      return this;
    };
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDemandTransparency.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsSimpleBarsOverlays', 'ChartElementsXAxisCircles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsMultiBrush', 'ChartElementsConstants'];
module.exports = ChartDemandTransparency;